<!-- defined 定制表单 -->
<template>
  <div class="preSale" :id="`extended-attrs-${elKey}`" v-if="data[`${$route.params.tableName}_formConfig`] || data[`${$route.params.tableName}`]">
    <!-- 多层panel -->
    <div
      v-if="multipleLevel.includes($route.params.tableName)"
      :key="`${$route.params.tableName}`"
      v-loading="data[`${$route.params.tableName}`].loading">
      <Collapse>
        <Panel :name="String(index)" v-for="(panel, index) in Object.keys(data[$route.params.tableName]).filter(i => i != 'loading')" :key="panel">
          {{ panel }}
          <p slot="content">
            <OmsForm :form-config="data[$route.params.tableName][panel]"  />
          </p>
        </Panel>
      </Collapse>
    </div>
    <!-- 单层form -->
    <div v-else :key="`${$route.params.tableName}_formConfig`" v-loading="data[`${$route.params.tableName}_formConfig`].loading">
      <OmsForm :form-config="data[`${$route.params.tableName}_formConfig`]" />
    </div>
    <div v-if="isNoData" class="no-data">{{t('暂无数据')}}</div>
  </div>
  <div v-else class="no-data">{{t('暂无数据')}}</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'extendedAttrs',
  data() {
    return {
      ID: this.$route.params.itemId && this.$route.params.itemId != 'New' ? this.$route.params.itemId : '-1', // 记录主界面传入的ID
      tableName: this.$route.params.tableName,
      modifyData: {},
      relationCode: '',
      configTables: [
        'CP_C_SHOP', 'PS_C_PRO', 'PS_C_SKU', 'CP_C_CUSTOMER','CP_C_RSTORE',
        'CP_C_WAREHOUSE', 'CP_C_SUPPLIER'
      ],
      data: {}, // 表单数据
      multipleLevel: ['PS_C_PRO']
    };
  },
  created() {
    if (this.multipleLevel.includes(this.tableName)) {
      this.$set(this.data, `${this.tableName}`, { loading: false })
      return
    }
    const init = {
      formData: [],
      formValue: {},
      isGrid: true,
      loading: false,
      iconSite: 'rightTop',
      flodClick: true,
      setColnum: 4, // 4列
      setRow: 2 // 2行
    }
    const formKey = `${this.tableName}_formConfig`
    this.$set(this.data, formKey, init)
  },
  mounted() {
    sessionStorage.removeItem('cpCShop_isUpdate');
    sessionStorage.removeItem('cpCShop_form');
    window.addEventListener('resize', this.pageStyle, false);
    window.addEventListener('saveResolve', this.Save);
    this.pageStyle();
    if (['PS_C_PRO', 'PS_C_SKU'].includes(this.tableName)) {
      // 这两个页面走watch（监听对应字段调接口），其他是初始时调接口
      const cols = new Map([
        ['PS_C_PRO', { colname: 'PS_C_CATEGORY_ID', colid: '' }], // 商品SPU
        ['PS_C_SKU', { colname: 'PS_C_CATEGORY_ID', colid: '' }], // 商品SKU
      ])
      if (cols.get(this.tableName)) {
        const { colname } = cols.get(this.tableName)
        // 初始化
        const it = vm.$store.state[R3.getModuleName()].copyDataForReadOnly.addcolums[0].childs.find(i => i.colname == colname)
        if (it && it.refobjid) { // 详情 or 复制
          R3.store.commit('customize/setCommodityCategoryId', it.refobjid);
        }
      }
    } else {
      this.init();
    }
  },
  activated() {
    this.pageStyle();
  },
  watch: {
    commodityCategoryId: {
      handler(val) {
        // 商品SPU单对象-监听商品品类
        if (this.tableName == 'PS_C_PRO') this.init();
      },
      immediate: true,
    },
    relationId: {
      handler(val) {
        // 商品SKU单对象-监听主表的SPU编码
        if (this.tableName == 'PS_C_SKU') this.init();
      },
    },
  },
  computed: {
    ...mapState('customize', ['commodityCategoryId', 'relationId']),
    elKey() {
      return Object.values(this.$route.params).join('-')
    },
    isNoData() {
      let formKey = `${this.tableName}_formConfig`
      return (!this.multipleLevel.includes(this.tableName) && this.data[formKey] && !this.data[formKey].formData.length)
      || (this.multipleLevel.includes(this.tableName) && !Object.keys(this.data[`${this.tableName}`]).filter(i => i != 'loading').length)
    }
  },
  methods: {
    ...mapMutations('customize', ['setCommodityCategoryId', 'setRelationId']),
    pageStyle() {
      //先清理页面
      setTimeout(() => {
        $('.preSale').parent().parent().find('.itemLabel').remove();
        $(`.ark-collapse[data-name="${this.$parent.$parent.$parent.$parent.name}"] .content.R3masterForm`).attr('style', '');
      }, 1000);
    },
    init() {
      if (!this.configTables.includes(this.tableName)) return;
      if (this.tableName == 'PS_C_PRO' && !this.commodityCategoryId) return;
      if (this.tableName == 'PS_C_SKU' && !this.relationId && !this.relationCode) return;
      let api = '';
      const params = {
        id: this.ID,
      };
      /* const getCopyId = () => {
        if (params.id == -1) {
          const copyId = sessionStorage.getItem(`${this.tableName}_definedForm_copy_itemId`)
          if (!!copyId) {
            params.id = copyId
          }
        }
      }
      getCopyId() // 获取复制单对象id */
      switch (this.tableName) {
        case 'CP_C_CUSTOMER': // 客户档案
          api = 'getExtendInfoForCustomer'
          break;
        case 'CP_C_RSTORE': // 门店档案
        case 'CP_C_WAREHOUSE': // 逻辑仓档案
          api = 'getExtendInfoForStoredim'
          params.tableName = this.tableName
          break;
        case 'CP_C_SUPPLIER': // 供应商档案
          api = 'getExtendInfoForSuppdim'
          break;
        case 'CP_C_SHOP': // 平台店铺档案
          api = 'getExtendInfo'
          break;
        case 'PS_C_PRO': // 商品SPU
          api = 'getExtendInfoForGood'
          params.tableName = this.tableName
          params.relationId = this.commodityCategoryId
          break;
        case 'PS_C_SKU': // 商品SKU
          api = 'getExtendInfoForGood'
          params.tableName = this.tableName
          params.relationId = -1
          params.relationCode = this.relationId
          break;
        default:
          break;
      }
      this.initForm({ api, params });
    },
    generateForm(data, formConfig) {
      const formData = [];
      data.forEach((item, index) => {
        switch (item.type) {
          case 'datetime':
            formData[index] = {
              style: 'date', // 输入框类型
              type: 'datetime', // 文本框类型的input
              label: item.label, // 输入框前文字
              value: item.name, // 输入框的值
              format: 'yyyy-MM-dd HH:mm:ss',
              width: '6', // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
              onChange: () => {
                const v = formConfig.formValue[item.name];
                formConfig.formValue[item.name] = v ? $utils.standardTimeConversiondateToStr(v) : '';
                this.setModifyData(item.name, formConfig);
              },
            };
            break;
          case 'text':
            formData[index] = {
              style: 'input',
              label: item.label,
              value: item.name,
              width: '6',
              inputblur: () => {
                this.setModifyData(item.name, formConfig);
              },
            };
            break;
          case 'number':
            formData[index] = {
              style: 'input',
              label: item.label,
              value: item.name,
              width: '6',
              regx: /^\d+(\.\d{0,2})?$/,
              inputblur: () => {
                this.setModifyData(item.name, formConfig);
              },
            };
            break;
          case 'select':
            if (item.dictionaryList && item.dictionaryList.length > 1000) {
              // 数据超级多（好几千甚至大于1w），页面渲染直接挂掉
              formData[index] = {
                style: 'input',
                label: item.label,
                value: item.name, // 暂时的
                width: '6',
                inputblur: () => {
                  this.setModifyData(item.name, formConfig);
                },
              };
            } else {
              formData[index] = {
                style: 'select', // 下拉框类型
                label: item.label, // 下拉框前的值
                width: '6', // 所占宽度宽度
                clearable: true, // 是否显示下来清空按钮
                value: item.name,
                multiple: false, // 布尔值,下拉框是否开启多选,默认为不开启
                options: item.dictionaryList,
                selectChange: () => {
                  this.setModifyData(item.name, formConfig);
                }, // 选中事件，默认返回选中的值
                clearSelect: (e) => {
                  this.setModifyData(item.name, formConfig);
                }, // 点击清空按钮回调
              };
            }
            break;
        }
        if (item.type == 'datetime') {
          formConfig.formValue[item.name] = item.value ? $utils.standardTimeConversiondateToStr(item.value) : '';
        } else if (['select'].includes(item.type)) {
          formConfig.formValue[item.name] = item.value ? Number(item.value) : '';
        } else {
          formConfig.formValue[item.name] = item.value || '';
        }
      });
      return formData
    },
    async initForm({ api, params }) {
      let formKey = `${this.tableName}_formConfig`
      if (this.multipleLevel.includes(params.tableName)) {
        formKey = `${this.tableName}`
      }
      if (!this.data.hasOwnProperty(formKey)) return; // 存在当前表单配置是上个页面，故作此判断
      this.data[formKey].loading = true
      const { data: { code, data } } = await this.service.commodityCenter[api](params)
      this.data[formKey].loading = false
      if (code != 0 || !data) return;
      this.modifyData = {};

      // 多层panel - 商品SPU
      if (this.multipleLevel.includes(params.tableName)) {
        for (let panel in data) {
          const init = {
            formData: [],
            formValue: {},
            isGrid: true,
            loading: false,
            iconSite: 'rightTop',
            flodClick: true,
            setColnum: 4, // 4列
            setRow: 2 // 2行
          }
          this.$set(this.data[params.tableName], panel, init)

          this.data[formKey][panel].formData = this.generateForm(data[panel], this.data[formKey][panel]);
          setTimeout(() => { // 展开panel
            $(`#extended-attrs-${this.elKey} .ark-collapse-item:not(.ark-collapse-item-active)`).each(function(index, i){
              $(i).find('.ark-collapse-header').click()
            })
          }, 300)
        }
        return
      } else {
        this.data[formKey].formData = this.generateForm(data, this.data[formKey]);
      }
      setTimeout(() => {
        this.data[formKey].loading = false
      }, 100);
    },
    setModifyData(name, formConfig) {
      const v = formConfig.formValue[name];
      this.modifyData[name] = v;
    },
    getFormData() {
      let formKey = `${this.tableName}_formConfig`
      let form = {}
      !this.multipleLevel.includes(this.tableName) && (form = this.data[formKey].formValue);
      let result = [];
      switch (this.tableName) {
        case 'CP_C_SHOP': // 平台店铺档案
        case 'CP_C_CUSTOMER': // 客户档案
        case 'CP_C_RSTORE': // 门店档案
        case 'CP_C_WAREHOUSE': // 逻辑仓档案
        case 'CP_C_SUPPLIER': // 供应商档案
          for (let key in form) {
            result.push({ column_name: key, column_value: form[key] });
          }
          break;
        case 'PS_C_SKU': // 商品SKU
          for (let key in form) {
            const data = {
              column_name: key,
              column_value: form[key],
            };
            const obj = $utils.queryForm(this.data[formKey], key);
            data.label = obj.label;
            data.select_label = obj.style == 'select' && form[key] ? obj.options.find((i) => i.value == form[key]).label : '';
            result.push(data);
          }
          break;
        default:
          if (this.multipleLevel.includes(this.tableName)) {
            for (let panel in this.data[this.tableName]) {
              form = this.data[this.tableName][panel].formValue
              for (let key in form) {
                const data = {
                  column_name: key,
                  column_value: form[key],
                };
                const obj = $utils.queryForm(this.data[this.tableName][panel], key);
                data.label = obj.label;
                data.select_label = obj.style == 'select' && form[key] ? obj.options.find((i) => i.value == form[key]).label : '';
                result.push(data);
              }
            }
          }
          break;
      }
      return result;
    },
    /**
     * 主表保存成功后的回调
     * @param {any} e 框架封装参数
     * @param {any} callBackObjId 复制保存成功后的id
     */
    Save(e, callBackObjId) {
      const cb = (ID) => {
        let api = '';
        const params = {
          ID,
          data: [],
        };
        switch (this.tableName) {
          case 'CP_C_CUSTOMER': // 客户档案
            api = 'saveExtendInfoForCustomer'
            break;
          case 'CP_C_RSTORE': // 门店档案
          case 'CP_C_WAREHOUSE': // 逻辑仓档案
            api = 'saveExtendInfoForStoredim'
            params.tableName = this.tableName
            break;
          case 'CP_C_SUPPLIER': // 供应商档案
            api = 'saveExtendInfoForSuppdim'
            break;
          case 'CP_C_SHOP': // 平台店铺档案
            api = 'saveExtendInfo';
            break;
          case 'PS_C_PRO': // 商品SPU
          case 'PS_C_SKU': // 商品SKU
            api = 'saveExtendInfoForGoods';
            params.tableName = this.tableName;
            break;
          default:
            break;
        }
        params.data = this.getFormData();

        vm.service.commodityCenter[api](params).then((res) => {
          if (res.data.code == 0) {
            const isUpdate = sessionStorage.getItem('cpCShop_isUpdate'); // 标准表单是否更新
            if (isUpdate == null || isUpdate != 'true') {
              this.$Message.success(res.data.message);
              const loadingName = this.$route.meta.moduleName.replace(/\./g, '-');
              this.$R3loading.show(loadingName);
              setTimeout(() => this.$R3loading.hide(loadingName), 300);
            }
          }
        });
      }
      if (e && e.detail.type == 'resolve') {
        let isModify = Object.keys(this.modifyData).length; // 定制表单是否更新
        sessionStorage.setItem('cpCShop_form', JSON.stringify(this.getFormData()));
        if (isModify) {
          // 触发监听保存子表
          cb(e.detail.res.data.data.objid)
        }
      } else if (!!e) {
        cb(callBackObjId)
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.pageStyle, false);
    window.removeEventListener('saveResolve', this.Save);
    switch (this.tableName) {
      case 'PS_C_PRO': // 商品SPU
        R3.store.commit('customize/setCommodityCategoryId', '');
        break;
      case 'PS_C_SKU': // 商品SKU
        R3.store.commit('customize/setRelationId', '');
        break;
    }
  },
};
</script>

<style lang="less" scoped>
.preSale {
  min-width: 70vw;
  min-height: 5vh;
  .business-form-main {
    border: none !important;
    padding: 0;
    .cusForm-content {
      padding: 0;
    }
  }
  /deep/ .ark-form-item {
    padding-top: 4px !important;
    .ark-form-item-label {
      width: 120px !important;
    }
    .ark-form-item-content {
      line-height: 30px !important;
      margin-left: 120px !important;
    }
  }
}
.no-data {
  text-align: center;
}
</style>
